import httpService from "../../Service/httpService";

const controller = "AgendaCitas";

export const getCitasMedico = async (id, idServicio, idMedico, mes, anio) => {
	const res = await httpService.get(
		`/${controller}/getCitasMedico/${id}/${idServicio}/${idMedico}/${mes}/${anio}`
	);
	return res.data;
};

export const getDatosCitaMedico = async (id, idPaciente, fecha, hora, idMedico, idServicio) => {
	const res = await httpService.get(
		`/${controller}/getDatosCitaMedico/${id}/${idPaciente}/${fecha}/${hora}/${idMedico}/${idServicio}`
	);
	return res.data;
};


export const saveCitaMedico = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveCitaMedico`, {
		...data,
	});
	return res;
};